// filename: extended-component.ts

import {Component, inject} from '@angular/core';
import {Router} from '@angular/router';

@Component({
	template: ``,
	standalone: true,
	styles: [],
})
export class ExtendedComponent {
	private readonly router: Router = inject(Router);

	protected reloadComponent() {
		// reload the component
		this.router
			.navigate([], {
				queryParams: {reload: true},
				queryParamsHandling: 'merge',
			})
			.then(
				() => {
					console.log('Component reloaded');
				},
				() => {
					console.log('Component reload failed');
				},
			);
	}
}
